import React from 'react';
import { CopyableId } from '../../modals/blocks';
import { initialsFor } from '../../utils';
import { SHIPPER_AVATAR_COLORS } from '../constants';

const LinkedShippers = ({ shippers = [], firstPosition = 0 }) => (
    <div className="flex flex-wrap gap-2">
        {shippers.map((shipper, index) => (
            <span
                key={shipper.client_id}
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white py-1 pl-1 pr-3"
            >
                <span
                    className={`flex size-6 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white ${
                        SHIPPER_AVATAR_COLORS[(firstPosition + index) % SHIPPER_AVATAR_COLORS.length]
                    }`}
                    aria-hidden="true"
                >
                    {initialsFor(shipper.business_name)}
                </span>
                <span className="text-[13px] font-semibold text-slate-900">{shipper.business_name}</span>
                <CopyableId label="Shipper ID" value={shipper.client_id} />
            </span>
        ))}
    </div>
);

export default LinkedShippers;
